export const dasherize = (string: string) => {
  let formattedString = string.replace(/ /g, "-");
  return formattedString.toLowerCase();
};
